import {convertLabelListToObjectList} from '../form-utils/Constants'
import {component} from '../form/Constant'

export const titleList = [
    {label: 'Unknown', value: 'unknown'},
    {label: 'Mr', value: 'mr'},
    {label: 'Mrs', value: 'mrs'},
    {label: 'Miss', value: 'miss'},
    {label: 'Ms', value: 'ms'},
    {label: 'Sir', value: 'sir'},
    {label: 'Madam', value: 'madam'},
]

export const hcpTitle = [
    {label: 'Doctor', value: 'doctor'},
    {label: 'Nurse', value: 'nurse'},
    {label: 'Carer', value: 'carer'},
]
export const identityWithHeldReasonList = [
    {
        label: 'Unknown',
        value: 'unknown',
    },
    {
        label: 'Record anonymised for legal/statutory reasons',
        value: 'recordAnonymisedForLegalstatutoryReasons',
    },
    {
        label: 'Record anonymised at request of Caldicott Guardian',
        value: 'recordAnonymisedAtRequestOfCaldicottGuardian',
    },
    {
        label: 'Record anonymised at request of PATIENT',
        value: 'recordAnonymisedAtRequestOfPatient',
    },
    {
        label: 'Record anonymised for other reason',
        value: 'recordAnonymisedForOtherReason',
    },
]
export const nhsNumberStatusList = [
    'Number present and verified',
    'Number present but not traced',
    'Trace required',
    'Trace attempted - No match or multiple match found',
    'Trace needs to be resolved - (NHS NUMBER or PATIENT detail conflict)',
    'Trace in progress',
    'Number not present and trace not required',
    'Trace postponed (baby under six weeks old)',
]
export const genderList = ['unknown', 'male', 'female', 'indeterminate']
export const materialStatusList = [
    {label: 'U (Unknown)', value: 'uUnknown'},
    {label: 'A (Separated)', value: 'aSeparated'},
    {label: 'D (Divorced)', value: 'dDivorced'},
    {label: 'M (Married/Civil Partner)', value: 'mMarriedCivilPartner'},
    {label: 'S (Single)', value: 'sSingle'},
    {label: 'W (Widowed)', value: 'wWidowed'},
    {label: 'X (Not Disclosed)', value: 'xNotDisclosed'},
]

export const methodOfAdmissionList = [
    {label: 'AE (ED)', value: 'aeEd'},
    {label: 'GP (Emergency GP Referral)', value: 'gpEmergencyGpReferral'},
    {
        label: 'TR (Transfer out of district)',
        value: 'trTransferOutOfDistrict',
    },
]

export const religionList = [
    {label: 'NK (Not Known)', value: 'nkNotKnown'},
    {label: 'BA (Baptist)', value: 'baBaptist'},
    {label: 'BU (Buddhist)', value: 'buBuddhist'},
    {label: 'CE (Church of England)', value: 'ceChurchOfEngland'},
    {label: 'CH (Christian Scientist)', value: 'chChristianScientist'},
    {label: 'CI (Church of Ireland)', value: 'ciChurchOfIreland'},
    {label: 'CS (Church of Scotland)', value: 'csChurchOfScotland'},
    {label: 'CT (Christian)', value: 'ctChristian'},
    {label: 'CW (Church of Wales)', value: 'cwChurchOfWales'},
    {label: 'HI (Hindu)', value: 'hiHindu'},
    {label: 'JE (Jewish)', value: 'jeJewish'},
    {label: 'JW (Jehovahs Witness)', value: 'jwJehovahsWitness'},
    {label: 'ME (Methodist)', value: 'meMethodist'},
    {label: 'MO (Mormon)', value: 'moMormon'},
    {label: 'MU (Muslim)', value: 'muMuslim'},
    {label: 'NC (Non Conformist)', value: 'ncNonConformist'},
    {label: 'NR (No Religion)', value: 'nrNoReligion'},
    {label: 'OF (Other Free Church)', value: 'ofOtherFreeChurch'},
    {label: 'OT (Other)', value: 'otOther'},
    {label: 'PB (Plymouth Brethren)', value: 'pbPlymouthBrethren'},
    {label: 'PR (Presbyterian)', value: 'prPresbyterian'},
    {label: 'QU (Quaker)', value: 'quQuaker'},
    {label: 'RC (Roman Catholic)', value: 'rcRomanCatholic'},
    {label: 'SA (Salvation Army)', value: 'saSalvationArmy'},
]
export const languageList = [
    {label: 'English', value: 'english'},
    {label: 'French', value: 'french'},
    {label: 'German', value: 'german'},
    {label: 'Polish', value: 'polish'},
    {label: 'Spanish', value: 'spanish'},
    {label: 'Chinese', value: 'chinese'},
    {label: 'Welsh', value: 'welsh'},
    {label: 'Irish', value: 'irish'},
    {label: 'Gaelic', value: 'gaelic'},
    {label: 'Cornish', value: 'cornish'},
    {label: 'Romany', value: 'romany'},
    {label: 'Albanian', value: 'albanian'},
    {label: 'Arabic', value: 'arabic'},
    {label: 'Belarusian', value: 'belarusian'},
    {label: 'Bengali', value: 'bengali'},
    {label: 'Bosnian', value: 'bosnian'},
    {label: 'Bulgarian', value: 'bulgarian'},
    {label: 'Burmese', value: 'burmese'},
    {label: 'Cantonese', value: 'cantonese'},
    {label: 'Catalan', value: 'catalan'},
    {label: 'Chechen', value: 'chechen'},
    {label: 'Croatian', value: 'croatian'},
    {label: 'Czech', value: 'czech'},
    {label: 'Danish', value: 'danish'},
    {label: 'Dutch', value: 'dutch'},
    {label: 'Estonian', value: 'estonian'},
    {label: 'Ethiopian', value: 'ethiopian'},
    {label: 'Filipino', value: 'filipino'},
    {label: 'Finnish', value: 'finnish'},
    {label: 'Flemish', value: 'flemish'},
    {label: 'Georgian', value: 'georgian'},
    {label: 'Greek', value: 'greek'},
    {label: 'Gujarati', value: 'gujarati'},
    {label: 'Hebrew', value: 'hebrew'},
    {label: 'Hindi', value: 'hindi'},
    {label: 'Hungarian', value: 'hungarian'},
    {label: 'Icelandic', value: 'icelandic'},
    {label: 'Indonesian', value: 'indonesian'},
    {label: 'Italian', value: 'italian'},
    {label: 'Japanese', value: 'japanese'},
]
export const accessibleList = [
    'Interpreter not needed',
    'Interpreter needed',
    'Interpreter declined',
]
export const accommodationStatusList = [
    {label: 'Unknown', value: 'unknown'},
    {
        label: 'Patient has own stable accommodation e.g. home/flat',
        value: 'patientHasOwnStableAccommodationEgHomeflat',
    },
    {
        label: 'Warden controlled accommodation',
        value: 'wardenControlledAccommodation',
    },
    {
        label: 'Residential institution WITHOUT routine nursing care',
        value: 'residentialInstitutionWithoutRoutineNursingCare',
    },
    {
        label: 'Residential institution WITH routine nursing care',
        value: 'residentialInstitutionWithRoutineNursingCare',
    },
    {label: 'Medical area', value: 'medicalArea'},
    {label: 'Homeless in night shelter', value: 'homelessInNightShelter'},
    {
        label: 'Homeless without accommodation',
        value: 'homelessWithoutAccommodation',
    },
    {
        label: 'Usual accommodation not given : patient refused',
        value: 'usualAccommodationNotGivenPatientRefused',
    },
    {
        label: 'Usual accommodation not given : patient physically unable',
        value: 'usualAccommodationNotGivenPatientPhysicallyUnable',
    },
    {
        label: 'Usual accommodation not known',
        value: 'usualAccommodationNotKnown',
    },
]
export const overseaList = [
    'Charging category A: Standard NHS -funded PATIENT',
    'Charging category B: Immigration Health Surcharge payee',
    'Charging category C: Charge-exempt Overseas Visitor (European Economic Area)',
    'Charging category D: Chargeable European Economic Area PATIENT',
    'Charging category E: Charge-exempt Overseas Visitor (non-European Economic Area)',
    'Charging category F: Chargeable non-European Economic Area PATIENT',
    'Decision Pending',
    'OVERSEAS VISITOR CHARGING CATEGORY Not Known (Not Recorded)',
]
export const ethnicOriginList = [
    'White British',
    'White Irish',
    'Any other White background',
    'White and Black Caribbean',
    'White and Black Caribbean',
    'White and Black African',
    'White and Asian',
    'Any other mixed background',
    'Indian',
    'Pakistani',
    'Bangladeshi',
    'Any other Asian background',
    'Caribbean',
    'African',
    'Any other Black background',
    'Chinese',
    'Any other ethnic group',
    'Not stated e.g. unwilling to state',
    'Not known e.g. unconscious',
]
export const locationList = [
    'Chelsea Pensioners Home',
    'West Wing (F1)',
    'West Wing (F2)',
    'West Wing (F3)',
    'East Wing (F1)',
    'East Wing (F2)',
    'East Wing (F3)',
]
export const nurseList = [
    {label: 'Nurse 1', value: '1'},
    {label: 'Nurse 2', value: '2'},
    {label: 'Nurse 3', value: '3'},
    {label: 'Nurse 4', value: '4'},
    {label: 'Nurse 5', value: '5'},
]

export const diagnosticList = [
    {label: 'Unknown', value: 'unknown'},
    {label: 'Airway / Breathing', value: 'airwayBreathing'},
    {label: 'Circulation / Chest', value: 'circulationChest'},
    {label: 'Gastrointestinal', value: 'gastrointestinal'},
    {label: 'Neurological', value: 'neurological'},
    {label: 'Skin', value: 'skin'},
    {label: 'Head and Neck', value: 'headAndNeck'},
    {label: 'Eye', value: 'eye'},
    {label: 'Trauma / Musculoskeletal', value: 'traumaMusculoskeletal'},
    {label: 'Genitourinary', value: 'genitourinary'},
    {label: 'ObGyn', value: 'obgyn'},
    {label: 'Environmental', value: 'environmental'},
    {
        label: 'Psychosocial / Behaviour Change',
        value: 'psychosocialBehaviourChange',
    },
    {label: 'General / Minor / Admin', value: 'generalMinorAdmin'},
    {label: 'Chest Pain', value: 'chestPain'},
    {label: 'Palpitations', value: 'palpitations'},
    {
        label: 'Electrical Exposure (inc. lightning)',
        value: 'electricalExposureIncLightning',
    },
    {label: 'Hypothermia', value: 'hypothermia'},
    {label: 'Frostbite', value: 'frostbite'},
    {label: 'Cardiac Arrest', value: 'cardiacArrest'},
    {label: 'Near Drowning', value: 'nearDrowning'},
    {
        label: 'Exposure to Communicable Disease (inc. needlestick / body fluids)',
        value: 'exposureToCommunicableDiseaseIncNeedlestickBodyFluids',
    },
    {label: 'Chemical Exposure', value: 'chemicalExposure'},
    {
        label: 'Noxious Inhalation - Gas / Fumes / Vapour / Smoke',
        value: 'noxiousInhalationGasFumesVapourSmoke',
    },
    {label: 'Poisoning from Any Source', value: 'poisoningFromAnySource'},
    {label: 'Red Eye', value: 'redEye'},
    {label: 'Foreign Body on Eye', value: 'foreignBodyOnEye'},
    {label: 'Pain In / Around Eye', value: 'painInAroundEye'},
    {label: 'Discharge from Eye', value: 'dischargeFromEye'},
    {label: 'Visual Disturbance', value: 'visualDisturbance'},
    {label: 'Photophobia', value: 'photophobia'},
    {label: 'Eye Injury', value: 'eyeInjury'},
    {label: 'Eye Review', value: 'eyeReview'},
    {label: 'Abdominal Pain', value: 'abdominalPain'},
    {label: 'export Constipation', value: 'exportConstipation'},
    {label: 'Diarrhoea', value: 'diarrhoea'},
    {label: 'Vomiting + / - Nausea', value: 'vomitingNausea'},
    {label: 'Nausea Without Vomiting', value: 'nauseaWithoutVomiting'},
    {label: 'Hiccoughs', value: 'hiccoughs'},
    {label: 'Jaundice', value: 'jaundice'},
    {label: 'Loss of Appetite', value: 'lossOfAppetite'},
    {label: 'Vomiting Blood', value: 'vomitingBlood'},
    {label: 'Rectal Pain', value: 'rectalPain'},
    {label: 'Blood in Stools', value: 'bloodInStools'},
    {label: 'Injury of Anus', value: 'injuryOfAnus'},
    {
        label: 'Food / Foreign Body in Oesophagus',
        value: 'foodForeignBodyInOesophagus',
    },
    {
        label: 'Foreign Body in Digestive Tract',
        value: 'foreignBodyInDigestiveTract',
    },
    {label: 'Foreign Body in Rectum', value: 'foreignBodyInRectum'},
    {label: 'Abdominal Distension', value: 'abdominalDistension'},
    {label: 'Difficulty Swallowing', value: 'difficultySwallowing'},
    {label: 'Fever', value: 'fever'},
    {label: 'Hyperglycaemia', value: 'hyperglycaemia'},
    {label: 'Hypoglycaemia', value: 'hypoglycaemia'},
    {
        label: 'Postoperative / wound care (no complication)',
        value: 'postoperativeWoundCareNoComplication',
    },
    {
        label: 'Postoperative / Medical Device with Complication',
        value: 'postoperativeMedicalDeviceWithComplication',
    },
    {label: 'Crying Infant', value: 'cryingInfant'},
    {label: 'Generalised Weakness', value: 'generalisedWeakness'},
    {label: 'Pale Colour', value: 'paleColour'},
    {label: 'Asymptomatic, No Symptoms', value: 'asymptomaticNoSymptoms'},
    {label: 'Blue Colour (cyanosis)', value: 'blueColourCyanosis'},
    {
        label: 'Social Problem (medically well)',
        value: 'socialProblemMedicallyWell',
    },
    {
        label: 'Direct Referral to Inpatient Unit',
        value: 'directReferralToInpatientUnit',
    },
    {label: 'Requesting Prescription', value: 'requestingPrescription'},
    {label: 'Pain on Passing Urine', value: 'painOnPassingUrine'},
    {label: 'Frequent Urination', value: 'frequentUrination'},
    {label: 'Unable to Pass Urine', value: 'unableToPassUrine'},
    {label: 'Low Urine Output', value: 'lowUrineOutput'},
    {label: 'Blood in Urine', value: 'bloodInUrine'},
    {label: 'Flank Pain', value: 'flankPain'},
    {label: 'Pain in Scrotum / Testes', value: 'painInScrotumTestes'},
    {
        label: 'Abnormal Swelling Groin Area',
        value: 'abnormalSwellingGroinArea',
    },
    {
        label: 'Pain in Genital Area (generalised)',
        value: 'painInGenitalAreaGeneralised',
    },
    {label: 'Injury to Genital Area', value: 'injuryToGenitalArea'},
    {label: 'Problem Related to Penis', value: 'problemRelatedToPenis'},
    {
        label: 'States Victim of Sexual Assault',
        value: 'statesVictimOfSexualAssault',
    },
    {label: 'Facial Pain (inc. toothache)', value: 'facialPainIncToothache'},
    {label: 'Neck Pain', value: 'neckPain'},
    {label: 'Ear : Pain', value: 'earPain'},
    {label: 'Ear : Injury', value: 'earInjury'},
    {label: 'Ear : Discharge', value: 'earDischarge'},
    {label: 'Ear : Hearing Loss', value: 'earHearingLoss'},
    {
        label: 'Ear : Ringing in Ears (tinnitus)',
        value: 'earRingingInEarsTinnitus',
    },
    {label: 'Ear : Foreign Body', value: 'earForeignBody'},
    {label: 'Nose : Bleeding from Nose', value: 'noseBleedingFromNose'},
    {label: 'Nose : Injury', value: 'noseInjury'},
    {label: 'Nose : Congestion', value: 'noseCongestion'},
    {label: 'Nose : Foreign Body', value: 'noseForeignBody'},
    {label: 'Throat : Swelling', value: 'throatSwelling'},
    {label: 'Throat : Sore', value: 'throatSore'},
    {label: 'Throat : Cough', value: 'throatCough'},
    {
        label: 'Throat : Foreign Body in Throat / Mouth',
        value: 'throatForeignBodyInThroatMouth',
    },
    {label: 'Headache', value: 'headache'},
    {label: 'Confusion', value: 'confusion'},
    {
        label: 'Drowsy (altered level of consciousness)',
        value: 'drowsyAlteredLevelOfConsciousness',
    },
    {label: 'Limb Weakness', value: 'limbWeakness'},
    {label: 'Facial Weakness', value: 'facialWeakness'},
    {label: 'Speech Disturbance', value: 'speechDisturbance'},
    {label: 'Seizure (fit)', value: 'seizureFit'},
    {label: 'Dizziness', value: 'dizziness'},
    {
        label: 'Numbness / Tingling (parasthesia)',
        value: 'numbnessTinglingParasthesia',
    },
    {label: 'Tremor', value: 'tremor'},
    {label: 'Falls / Unsteady on Feet', value: 'fallsUnsteadyOnFeet'},
    {label: 'Insomnia', value: 'insomnia'},
    {label: 'Short of Breath', value: 'shortOfBreath'},
    {label: 'Difficulty Breathing', value: 'difficultyBreathing'},
    {label: 'Noisy Breathing', value: 'noisyBreathing'},
    {label: 'Collapse / Fainting Episode', value: 'collapseFaintingEpisode'},
    {
        label: 'Collapse / Fainting Episode with Loss of Consciousness',
        value: 'collapseFaintingEpisodeWithLossOfConsciousness',
    },
    {
        label: 'Coughing up Blood (haemoptysis)',
        value: 'coughingUpBloodHaemoptysis',
    },
    {label: 'Swollen Legs (both)', value: 'swollenLegsBoth'},
    {label: 'Swollen Leg (single)', value: 'swollenLegSingle'},
    {label: 'Cold Painful Limb', value: 'coldPainfulLimb'},
    {
        label: 'Foreign Body in Respiratory Tract',
        value: 'foreignBodyInRespiratoryTract',
    },
    {
        label: 'Cardiac Arrest Due to Trauma',
        value: 'cardiacArrestDueToTrauma',
    },
    {
        label: 'Infant with Episodes not Breathing (apnoea)',
        value: 'infantWithEpisodesNotBreathingApnoea',
    },
    {label: 'Respiratory Arrest', value: 'respiratoryArrest'},
    {
        label: 'Pregnancy Related : Less Than 20 Weeks',
        value: 'pregnancyRelatedLessThan20Weeks',
    },
    {
        label: 'Pregnancy Related : Greater Than 20 Weeks',
        value: 'pregnancyRelatedGreaterThan20Weeks',
    },
    {label: 'Vaginal Bleeding (abnormal)', value: 'vaginalBleedingAbnormal'},
    {label: 'Foreign Body in Vagina', value: 'foreignBodyInVagina'},
    {label: 'Problem Related to Vagina', value: 'problemRelatedToVagina'},
    {label: 'Problem Related to Breast', value: 'problemRelatedToBreast'},
    {
        label: 'Drug / Alcohol Intoxication or Withdrawal',
        value: 'drugAlcoholIntoxicationOrWithdrawal',
    },
    {label: 'Self-harm', value: 'selfharm'},
    {label: 'Suicidal Thoughts', value: 'suicidalThoughts'},
    {label: 'Depressive Feelings', value: 'depressiveFeelings'},
    {label: 'Feeling Anxious', value: 'feelingAnxious'},
    {label: 'Behaviour : Unusual', value: 'behaviourUnusual'},
    {
        label: 'Behaviour : Agitated / Violent',
        value: 'behaviourAgitatedViolent',
    },
    {label: 'Hallucinations / Delusions', value: 'hallucinationsDelusions'},
    {label: 'Wound : Abrasion', value: 'woundAbrasion'},
    {label: 'Wound : Laceration', value: 'woundLaceration'},
    {label: 'Wound : Puncture', value: 'woundPuncture'},
    {label: 'Wound : Sting', value: 'woundSting'},
    {label: 'Wound : Bite', value: 'woundBite'},
    {label: 'Burn', value: 'burn'},
    {label: 'Rash', value: 'rash'},
    {
        label: 'Localised Swelling / Redness / Lumps / Bumps',
        value: 'localisedSwellingRednessLumpsBumps',
    },
    {label: 'Itching', value: 'itching'},
    {label: 'Spontaneous Bruising', value: 'spontaneousBruising'},
    {
        label: 'Foreign Body in Skin / Subcutaneous Tissue',
        value: 'foreignBodyInSkinSubcutaneousTissue',
    },
    {label: 'Head Injury', value: 'headInjury'},
    {label: 'Facial Injury', value: 'facialInjury'},
    {label: 'Injury of Neck', value: 'injuryOfNeck'},
    {
        label: 'Injury of Shoulder / Arm / Elbow / Wrist / Hand',
        value: 'injuryOfShoulderArmElbowWristHand',
    },
    {
        label: 'Injury of Hip / Leg / Knee / Ankle / Foot',
        value: 'injuryOfHipLegKneeAnkleFoot',
    },
    {label: 'Injury of Thorax', value: 'injuryOfThorax'},
    {label: 'Injury of Abdomen', value: 'injuryOfAbdomen'},
    {
        label: 'Injury of Cervical Region of Back (disorder)',
        value: 'injuryOfCervicalRegionOfBackDisorder',
    },
    {label: 'Injury of Upper Back', value: 'injuryOfUpperBack'},
    {label: 'Injury of Lower Back', value: 'injuryOfLowerBack'},
    {label: 'Backache (no recent injury)', value: 'backacheNoRecentInjury'},
    {
        label: 'Pain in Shoulder / Arm / Elbow / Wrist / Hand',
        value: 'painInShoulderArmElbowWristHand',
    },
    {
        label: 'Pain in Hip / Leg / Knee / Ankle / Foot',
        value: 'painInHipLegKneeAnkleFoot',
    },
    {label: 'Joint Swelling', value: 'jointSwelling'},
    {
        label: 'Major Trauma (serious injury &gt;1 body area)',
        value: 'majorTraumaSeriousInjuryGt1BodyArea',
    },
    {label: 'Traumatic Amputation', value: 'traumaticAmputation'},
]
export const nokRelationList = [
    {label: 'UN (Unknown)', value: 'unUnknown'},
    {label: 'AU (Aunt)', value: 'auAunt'},
    {label: 'BR (Brother)', value: 'brBrother'},
    {label: 'CL (Common Law)', value: 'clCommonLaw'},
    {label: 'CO (Cousin)', value: 'coCousin'},
    {label: 'DA (Daughter)', value: 'daDaughter'},
    {label: 'FA (Father)', value: 'faFather'},
    {label: 'FP (Foster Parent)', value: 'fpFosterParent'},
    {label: 'FR (Friend)', value: 'frFriend'},
    {label: 'GC (Grandchild)', value: 'gcGrandchild'},
    {label: 'GM (Grandmother)', value: 'gmGrandmother'},
    {label: 'GP (Grandfather)', value: 'gpGrandfather'},
    {label: 'GU (Guardian)', value: 'guGuardian'},
    {label: 'HU (Husband)', value: 'huHusband'},
    {label: 'MO (Mother)', value: 'moMother'},
    {label: 'NE (Nephew)', value: 'neNephew'},
    {label: 'NI (Niece)', value: 'niNiece'},
    {label: 'ON (Other Not Related)', value: 'onOtherNotRelated'},
    {label: 'OR (Other Relative)', value: 'orOtherRelative'},
    {label: 'PA (Parent)', value: 'paParent'},
    {label: 'PT (Partner)', value: 'ptPartner'},
    {label: 'SI (Sister)', value: 'siSister'},
    {label: 'SO (Son)', value: 'soSon'},
    {label: 'UN (Uncle)', value: 'unUncle'},
]

export const emergency_care_list = [
    'Unplanned First Emergency Care Attendance for a new clinical condition (or deterioration of a chronic condition).',
    'Unplanned Follow-up Emergency Care Attendance for the same or a related clinical condition and within 7 days of the First Emergency Care Attendance  at  THIS Emergency Care Department',
    'Unplanned Follow-up Emergency Care Attendance for the same or a related clinical condition and within 7 days of the First Emergency Care Attendance  at ANOTHER Emergency Care Department',
    'Planned Follow-up Emergency Care Attendance  within 7 days of the First Emergency Care Attendance at THIS Emergency Care Department',
    'Not Applicable (Patient dead on arrival at Emergency Care Department)',
]
export const placeOfIncidentList = [
    '1 (Home - Living Room)',
    '2 (Home - Kitchen)',
    '3 (Home - Garage)',
    '4 (Home - Hallway)',
    '5 (Home - Stairway)',
    '6 (Home - Bathroom)',
    '7 (Home - Bedroom)',
    '8 (Home - Utility Room)',
    '9 (Home - Study)',
    '10 (Home - Dining Room)',
    '11 (Home - Home Gym)',
    '12 (Home - Conservatory)',
    '13 (Home - Garden)',
    '14 (Home - Outbuilding / Shed)',
    '15 (Home - Swimming Pool)',
    '16 (Home - Pond)',
    '17 (Residential Building - Residential / Nursing Home)',
    '18 (Residential Building - Hotel / Bed and Breakfast)',
    '19 (Residential Building - Student Accommodation )',
    '20 (Residential Building - Hostel Homeless)',
    '21 (Entertainment - Inside Licensed Premises : Pub Club Bar)',
    '22 (Entertainment - Outside Licensed Premises : Pub Club Bar)',
    '23 (Entertainment - Music Venue e.g. Nightclub)',
    '24 (Entertainment - Live Music Venue e.g. Concert Hall)',
    '25 (Entertainment - Music Festival Site)',
    '26 (Entertainment - Cinema)',
    '27 (Entertainment - Theatre)',
    '28 (Public Area - Educational Establishment)',
    '29 (Public Area - Retail Service Area e.g. Shop )',
    '30 (Public Area - Workplace)',
    '31 (Public Area - Public Building)',
    '32 (Public Area - Sports Facility)',
    '33 (Public Area - Medical / Clinical Area)',
    '34 (Transport - Private Vehicle)',
    '35 (Transport - Private Hire Vehicle / Taxi)',
    '36 (Transport - Bus)',
    '37 (Transport - Tram)',
    '38 (Transport - Train)',
    '39 (Transport - Underground Train )',
    '40 (Transport - Transport Interchange : Airport / Station)',
    '41 (Outdoor - Road / Pavement)',
    '42 (Outdoor - Recreational Area)',
    '43 (Outdoor - Countryside)',
    '44 (Outdoor - Farm)',
    '45 (Outdoor - export Construction Area)',
    '46 (Outdoor - Military Barracks Army)',
    '47 (Outdoor - Water / Waterside)',
    '48 (Outdoor - Derelict Building)',
    '49 (Custodial Services - Police)',
    '50 (Custodial Services - Prison)',
    '51 (Custodial Services - Detention Centre)',
    '52 (Public Area - Ice Rink)',
    'BF (Entertainment - Boomtown Festival)',
    'X (Refused to Answer)',
]
export const ambulance_organisation_identifier_list = ['SCAS', 'Other']
export const RtcInfoList = [
    'Cyclist without Helmet',
    'Driver with Seat Belt',
    'Driver - no Seat Belt',
    'Front Seat Passenger Wearing Seat Belt',
    'Front Seat Passenger - No Seat Belt',
    'Cyclist with Helmet',
    'Motorcuclist - Driver',
    'Not Relevant',
    'Motorcyclist - Pillion Passanger',
    'Rear Sear Passenger with Seat Belt',
    'Rear Sear Passenger - No Belt',
    'Pedestrian',
    'Refused to Answer',
]
export const attendanceSourceList = [
    'Self / family / friends / education / work colleague',
    '232',
    'Non-NHS telephone / internet advice',
    'GP / practice nurse',
    'Out of hours GP service',
    'NHS telephone / internet advice e.g. NHS 111',
    'Emergency department',
    'Urgent care service',
    'Outpatient service inc. ambulatory care',
    'Inpatient',
    'Private specialist',
    'Community nurse (not practice nurse)',
    'Health visitor',
    'Midwife',
    'School nurse',
    'Community mental health nurse',
    'Mental health assessment team',
    'Social services',
    'Older persons day care centre',
    'Homeless persons drop in centre',
    'Custodial services : prison',
    'Custodial services : detention centre',
    'Pharmacist (including community pharmacist)',
    'Dentist (including community dentist)',
    'Optician / optometrist',
    'Advanced care practitioner',
    'Ambulance service - patient in transit',
    'Police service / forensic medical officer',
    'Fire service',
    'Search and rescue',
    'Coastguard',
    'Mountain rescue',
]
export const modeOfArrivalList = [
    'Patient arranged own transport / walk-in',
    'Public transport / taxi',
    'Emergency road ambulance',
    'Emergency road ambulance with medical escort',
    'Non-emergency road ambulance',
    'Helicopter',
    'Fixed wing / medical repatriation by air',
    'Custodial services : prison / detention centre transport',
    'Police transport',
]
export const carerList = [
    'Patient arranged own transport / walk-in',
    'Public transport / taxi',
    'Emergency road ambulance',
    'Emergency road ambulance with medical escort',
    'Non-emergency road ambulance',
    'Helicopter',
    'Fixed wing / medical repatriation by air',
    'Custodial services : prison / detention centre transport',
    'Police transport',
]

const sicknessOptions = [
    {
        label: 'Maternity with Covid',
        value: 'maternityWithCovid',
        checked: false,
    },
    {
        label: 'Heart Patients with AF',
        value: 'heartPatientsWithAF',
        checked: false,
    },
    {label: 'COPD', value: 'copd', checked: false},
    {label: 'Diabetics', value: 'diabetics', checked: false},
    {label: 'Cancer', value: 'cancer', checked: false},
    {label: 'Covid', value: 'covid', checked: false},
    {label: 'Falls', value: 'fall', checked: false},
]

export const patientKeys = {
    userAccount: 'userAccount',
    username: 'username',
    email: 'email',

    basicInformation: 'basicInformation',
    nhsNumber: 'nhsNumber',
    title: 'title',
    firstName: 'firstName',
    lastName: 'lastName',
    gender: 'gender',
    dob: 'dob',
    avatar: 'avatar',
    active: 'active',

    contactInformation: 'contactInformation',
    address: 'address',
    type: 'type',
    addressType: 'addressType',

    hospitalInformation: 'hospitalInformation',
    hospitalName: 'hospitalName',
    hospitalNumber: 'hospitalNumber',

    healthCarePractitioner: 'healthCarePractitioner',
    healthCarePractitioners: 'healthCarePractitioners',
    hcpAssignment: 'assignHCP',

    pathwayInformation: 'pathwayInformation',
    pathway: 'pathway',

    additionalInformation: 'additionalInformation',
    currentLocation: 'currentLocation',
    occupation: 'occupation',
    maritalStatus: 'maritalStatus',
    religion: 'religion',
    accommodationStatus: 'accommodationStatus',
    identityWithHeldReason: 'identityWithHeldReason',
    diagnostic: 'diagnostic',
    sickness: 'sickness',
    sicknessLevel: 'sicknessLevel',
    sicknessStatus: 'sicknessStatus',

    nokInformation: 'NOKInformation',
    nokFullName: 'NOKFullName',
    nokEmail: 'NOKEmail',
    nokDescription: 'NOKDescription',
    nokRelationShip: 'NOKRelationship',

    nokContactInformation: 'NOKContactInformation',
    nokAddress: 'address',

    roleInformation: 'roleInformation',
    role: 'role',

    generalPractitioner: 'generalPractitioner',

    supportTeam: 'supportTeam',
    discharge: 'discharge',
    assignedStatus: 'assignedStatus',
    pathways: 'pathways',

    staticLists: 'staticLists',
}

export const patientOptionsList = {
    title: titleList,
    hcpTitle: hcpTitle,
    gender: convertLabelListToObjectList(genderList),
    maritalStatus: materialStatusList,
    religion: religionList,
    accommodationStatus: accommodationStatusList,
    identityWithHeldReason: identityWithHeldReasonList,

    hospital: [],
    diagnostic: diagnosticList,
    sickness: sicknessOptions,
}

export const patientLabelKeys = {
    userAccount: 'userAccount',
    username: 'username',
    email: 'email',

    basicInformation: 'basicInformation',
    title: 'title',
    firstName: 'firstName',
    lastName: 'lastName',
    gender: 'gender',
    dob: 'DOB',
    avatar: 'avatar',

    contactInformation: 'contactInformation',
    address: 'address',

    hospitalInformation: 'hospitalInformation',
    hospitalName: 'hospitalName',
    hospitalNumber: 'hospitalNumber',

    healthCarePractitioner: 'healthCarePractitioner',
    hcpAssignment: 'assignHCP',

    pathwayInformation: 'pathwayInformation',
    pathway: 'pathway',

    additionalInformation: 'additionalInformation',
    occupation: 'occupation',
    maritalStatus: 'maritalStatus',
    religion: 'religion',
    accommodationStatus: 'accommodationStatus',
    identityWithHeldReason: 'identityWithHeldReason',
    diagnostic: 'diagnostic',
    sickness: 'sickness',

    nokInformation: 'NOKInformation',
    nokFullName: 'NOKFullName',
    nokEmail: 'NOKEmail',
    nokDescription: 'NOKDescription',
    nokRelationShip: 'NOKRelationship',

    nokContactInformation: 'NOKContactInformation',
    nokAddress: 'address',

    roleInformation: 'roleInformation',
    role: 'role',

    generalPractitioner: 'generalPractitioner',

    supportTeam: 'supportTeam',
}

export const patientList = [
    {
        key: patientKeys.hospitalInformation,
        description: 'Select the hospital the patient is assigned to',
        required: true,
        children: [
            {
                key: patientKeys.hospitalName,
                component: component.dropdown,
                options: [],
                placeholder: 'Select a hospital - Field is required',
                required: true,
            },
        ],
    },
    {
        key: patientKeys.healthCarePractitioner,
        description: 'Assign HCP(s) responsible for patient care.',
        required: true,
        children: [
            {
                key: patientKeys.hcpAssignment,
                component: component.multiSelect,
                options: [],
                placeholder: 'Select HCP(s) - Field is required',
                required: true,
            },
        ],
    },
    {
        key: patientKeys.pathwayInformation,
        description: 'Select the patient’s pathway(s)',
        children: [
            {
                key: patientKeys.pathway,
                component: component.multiSelect,
                options: [],
                placeholder: 'Select pathway(s)',
            },
        ],
    },
    {
        key: patientKeys.supportTeam,
        description: 'Assign the patient to Support Team',
        children: [
            {
                key: patientKeys.supportTeam,
                component: component.multiSelect,
                options: [],
                placeholder: 'Select support team(s)',
            },
        ],
    },
    {
        key: patientKeys.userAccount,
        description:
            'Fill in the following information to create a patient’s account.',
        note: 'The account will be sent to the patient via email after completing the form',
        children: [
            {
                key: patientKeys.username,
                component: component.inputText,
                placeholder: 'Auto-generated if leaving blank',
                keyFilter: true,
                defaultValue: '',
            },
            {
                key: patientKeys.email,
                component: component.inputText,
                keyFilter: true,
                placeholder: "Input patient's email - Field is required",
                required: true,
                defaultValue: '',
            },
        ],
    },
    {
        key: patientKeys.basicInformation,
        description: 'Fill in the patient information details.',
        required: true,
        children: [
            {
                key: patientKeys.nhsNumber,
                label: 'NHS Number',
                component: component.inputText,
                placeholder: "Input patient's NHS number - Field is required",
                required: true,
            },
            {
                key: patientKeys.title,
                component: component.dropdown,
                options: titleList,
                defaultValue: titleList[0].value,
            },
            {
                key: patientKeys.firstName,
                component: component.inputText,
                placeholder: "Input patient's first name - Field is required",
                required: true,
            },
            {
                key: patientKeys.lastName,
                component: component.inputText,
                placeholder: "Input patient's last name",
            },
            {
                key: patientKeys.gender,
                component: component.dropdown,
                options: patientOptionsList.gender,
                defaultValue: genderList[0],
            },
            {
                key: patientKeys.dob,
                label: patientLabelKeys.dob,
                component: component.inputMask,
                placeholder: 'Input date of birth - Field is required',
                required: true,
            },
            {
                key: patientKeys.avatar,
                component: component.fileUpload,
            },
        ],
    },
    {
        key: patientKeys.contactInformation,
        description: 'Fill in the patient contact details.',
        required: true,
        children: [
            {
                key: 'address',
                hideHeader: true,
                component: component.address,
                className: 'col-12 grid  px-0',
                childrenClassName: 'md:col-6 col-12 px-1',
            },
        ],
    },
    {
        key: patientKeys.additionalInformation,
        description: "Fill in the patient's additional information",
        children: [
            {
                key: patientKeys.currentLocation,
                component: component.inputText,
                placeholder: 'Input current location here',
            },
            {
                key: patientKeys.occupation,
                component: component.inputText,
                placeholder: 'Input occupation here',
            },
            {
                key: patientKeys.maritalStatus,
                component: component.dropdown,
                options: patientOptionsList.maritalStatus,
                defaultValue: materialStatusList[0].value,
            },
            {
                key: patientKeys.religion,
                component: component.dropdown,
                options: patientOptionsList.religion,
                defaultValue: religionList[0].value,
            },
            {
                key: patientKeys.accommodationStatus,
                component: component.dropdown,
                options: patientOptionsList.accommodationStatus,
                defaultValue: accommodationStatusList[0].value,
            },
            {
                key: patientKeys.identityWithHeldReason,
                component: component.dropdown,
                options: patientOptionsList.identityWithHeldReason,
                defaultValue: identityWithHeldReasonList[0].value,
            },
            {
                key: patientKeys.diagnostic,
                component: component.dropdown,
                options: patientOptionsList.diagnostic,
                defaultValue: diagnosticList[0].value,
            },
        ],
    },
    {
        key: 'generalPractitionerInformation',
        description:
            'Select or fill in the General Practitioner’s information details.',
        required: true,
        children: [
            {
                key: 'gpId',
                hideHeader: true,
                component: component.generalPractitioner,
                className: 'col-12 grid  px-0',
                childrenClassName: 'md:col-6 col-12 px-1',
            },
        ],
    },
    // {
    //     key: patientKeys.nokContactInformation,
    //     description: "Fill in the patient's NOK contact information",
    //     children: [
    //         {
    //             key: patientKeys.nokAddress,
    //             hideHeader: true,
    //             component: component.address,
    //             className:'col-12 grid px-0',
    //             childrenClassName:'md:col-6 col-12  px-1',
    //         },
    //     ],
    // },
]

export const patientColumnList = [
    {
        key: 'id',
        expander: true,
    },
    {
        key: 'fullName',
        body: rowData =>
            rowData.data && rowData.data.fullname
                ? rowData.data.fullname
                : rowData.data.fullname
                ? rowData.data.fullname
                : `${rowData.data.firstname}  ${rowData.data.lastname}`,
    },
    {
        key: 'role',
        body: rowData =>
            rowData.data && rowData.data.type && rowData.data.type === 2
                ? 'Nurse'
                : 'Patient',
    },
    {
        key: 'userName',
        body: rowData =>
            rowData.data && rowData.data.username ? rowData.data.username : '-',
    },
    {
        key: 'email',
    },
]

export const patientFilterList = [
    {
        key: patientKeys.basicInformation,
        children: [
            {
                key: patientKeys.title,
                component: component.multiSelect,
                options: patientOptionsList.title,
            },
            {
                key: patientKeys.gender,
                component: component.multiSelect,
                options: patientOptionsList.gender,
            },
        ],
    },
    {
        key: patientKeys.additionalInformation,
        children: [
            {
                key: patientKeys.maritalStatus,
                component: component.multiSelect,
                options: patientOptionsList.maritalStatus,
            },
            {
                key: patientKeys.religion,
                component: component.multiSelect,
                options: patientOptionsList.religion,
            },
            {
                key: patientKeys.accommodationStatus,
                component: component.multiSelect,
                options: patientOptionsList.accommodationStatus,
            },
            {
                key: patientKeys.identityWithHeldReason,
                component: component.multiSelect,
                options: patientOptionsList.identityWithHeldReason,
            },
            {
                key: patientKeys.diagnostic,
                component: component.multiSelect,
                options: patientOptionsList.diagnostic,
            },
        ],
    },
    {
        key: patientKeys.address,
        children: [
            {
                key: patientKeys.address,
                component: component.address,
            },
        ],
    },
    {
        key: patientKeys.discharge,
        children: [
            {
                key: 'status',
                component: component.dropdown,
                options: [
                    {label: 'Discharged', value: true},
                    {label: 'Undischarged', value: false},
                ],
            },
        ],
    },
    {
        key: patientKeys.healthCarePractitioner,
        children: [
            {
                key: 'assignedStatus',
                component: component.dropdown,
                options: [
                    {label: 'Assigned', value: true},
                    {label: 'Unassigned', value: false},
                ],
            },
            // {
            //     key: 'assignedBy',
            //     component: component.dropdown,
            //     options: [
            //         {label: 'Assigned', value: true},
            //         {label: 'Unassigned', value: false},
            //     ],
            // },
        ],
    },
]

export const treatAsRole = {
    HCP: 'hcp',
    Patient: 'patient',
}

export const patientHiddenColumns = [
    {key: 'email'},
    {key: 'fullName'},
    {key: 'title'},
    {key: 'gender'},
    {key: 'dob'},
    {key: 'accessCode'},
    {key: 'userCode'},
    {key: 'thirdPartyCode'},
    {key: 'hospitalNumber'},
    {key: 'hospitalName'},
    {key: 'nhsNumber'},
    {key: 'type'},
    {key: 'address'},
    {key: 'postalCode'},
    {key: 'phone'},
    {key: 'identityWithHeldReason'},
    {key: 'maritalStatus'},
    {key: 'religion'},
    {key: 'accommodationStatus'},
    {key: 'diagnostic'},
]
